import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col-reverse gap-28 gap-x-80 self-center justify-self-center py-[3.75rem] tablet:mt-[8.75rem] tablet:flex-row tablet:justify-center tablet:self-start tablet:pt-0" }
const _hoisted_2 = { class: "tablet:w-full tablet:max-w-[24.25rem]" }
const _hoisted_3 = { class: "h6 tablet:h5" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "mt-20 flex gap-x-12 tablet:mt-24" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "mt-16 block text-14 text-orange tablet:mt-20"
}
const _hoisted_8 = { class: "tablet:w-full tablet:max-w-[25.75rem]" }
const _hoisted_9 = { class: "text-22 tablet:text-26" }
const _hoisted_10 = { class: "flex items-center gap-x-12" }
const _hoisted_11 = { class: "text-14 text-black-400 tablet:text-18" }
const _hoisted_12 = { class: "overflow-hidden" }
const _hoisted_13 = ["checked", "disabled", "onChange"]
const _hoisted_14 = { class: "flex flex-col gap-y-8 text-14 font-medium" }
const _hoisted_15 = {
  key: 1,
  class: "rounded-4 bg-[#D5EBFF] py-4 px-8 text-12 text-[#003A5A]"
}
const _hoisted_16 = {
  key: 0,
  class: "pb-16"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "flex flex-col overflow-hidden" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onUpdate:modelValue", "value"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "overflow-hidden" }
const _hoisted_23 = ["onUpdate:modelValue", "placeholder"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_image = _resolveComponent("v-image")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-accent btn-arrow__before mb-24 w-fit before:rotate-180 hover:before:rotate-180",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('updateModal', 'OPENED', 'CONFIRM_REDIRECTION')))
      }, _toDisplayString($data.locale.return_to_homepage_link), 1),
      _createElementVNode("h1", _hoisted_3, _toDisplayString($data.locale.title), 1),
      _createElementVNode("p", {
        class: "mt-8 max-w-[35ch] text-14 text-black-700 tablet:text-16",
        innerHTML: $data.locale.subtitle
      }, null, 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        ($props.order.lineItems.length > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-secondary btn-small w-100 border-2 border-black-900 text-center text-18",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('navigate', 'RETURN_ENTIRE_ORDER', 'right')))
            }, _toDisplayString($data.locale.back_button), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-small w-100 text-center text-18",
          disabled: !$data.itemsToReturnLocal.length || !$options.everyItemHasReason,
          onClick: _cache[2] || (_cache[2] = (...args) => ($options.confirmItemsToReturn && $options.confirmItemsToReturn(...args)))
        }, _toDisplayString($data.locale.next_button), 9, _hoisted_6)
      ]),
      ($options.shouldDisplayWarning)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($data.locale.error_not_every_item_has_reason), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        type: "button",
        class: "flex w-full items-center justify-between border-b border-t border-black-300 px-16 py-12 tablet:pointer-events-none tablet:p-24",
        onClick: _cache[3] || (_cache[3] = $event => (_ctx.$emit('toggleItemsDropdown')))
      }, [
        _createElementVNode("span", _hoisted_9, _toDisplayString($data.locale.your_order), 1),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _createTextVNode(_toDisplayString($data.itemsToReturnLocal.length) + "/" + _toDisplayString($props.order?.lineItems.length) + " ", 1),
            ($props.order?.lineItems.length > 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString($data.locale.item_count_plural), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString($data.locale.item_count), 1)
                ], 64))
          ]),
          (_openBlock(), _createElementBlock("svg", {
            width: "14",
            height: "10",
            viewBox: "0 0 16 10",
            fill: "none",
            class: _normalizeClass(["transition-transform duration-200 ease-in-out tablet:hidden", {'rotate-180': $props.itemsDropdownStatus === 'OPENED'}])
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("path", {
              d: "M1.25 1.625L8 8.375L14.75 1.625",
              stroke: "#121212",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]), 2))
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["grid transition-grid-template-rows duration-500 tablet:grid-rows-1", $props.itemsDropdownStatus === 'OPENED' ? 'grid-rows-1' : 'grid-rows-0'])
      }, [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.order.lineItems, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.uniqueKey
            }, [
              _createElementVNode("label", {
                class: _normalizeClass(["flex cursor-pointer items-center gap-x-16 pt-20 pb-10", {
                'cursor-default': item.isKitParentVariant || item.isExcludedFromRefund,
              }])
              }, [
                _createElementVNode("input", {
                  checked: 
                  $data.itemsToReturnLocal.some(
                    (itemToReturnLocal) => itemToReturnLocal.uniqueKey === item.uniqueKey
                  )
                ,
                  disabled: item.isKitParentVariant || item.isExcludedFromRefund,
                  type: "checkbox",
                  class: "filter-checkbox absolute -z-10 opacity-0",
                  onChange: $event => ($options.toggleItemToReturn(item))
                }, null, 40, _hoisted_13),
                _createElementVNode("span", {
                  class: _normalizeClass({
                  invisible: item.isKitParentVariant || item.isExcludedFromRefund,
                })
                }, null, 2),
                _createVNode(_component_v_image, {
                  lazyloaded: "",
                  source: item.imageUrl,
                  alt: "",
                  width: 150,
                  class: _normalizeClass(["aspect-return-portal-item h-full w-full max-w-[4.8125rem] object-cover object-center", {'opacity-50': item.isExcludedFromRefund}])
                }, null, 8, ["source", "class"]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", {
                    class: _normalizeClass({'opacity-50': item.isExcludedFromRefund})
                  }, _toDisplayString(item.title), 3),
                  (!item.isKitParentVariant)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass({'opacity-50': item.isExcludedFromRefund})
                      }, _toDisplayString($options.formattedPrice(item.price * 100)), 3))
                    : _createCommentVNode("", true),
                  (item.isExcludedFromRefund)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($data.locale.not_eligible_for_return), 1))
                    : _createCommentVNode("", true)
                ])
              ], 2),
              (
                $data.itemsToReturnLocal.find((itemToReturn) => itemToReturn.uniqueKey === item.uniqueKey)
              )
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "mb-12 flex w-full items-center justify-between border-b border-black-300 py-4 pt-10 font-medium",
                      onClick: $event => (item.isSelectReasonDropdownOpen = !item.isSelectReasonDropdownOpen)
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass({
                    'before:mr-4 before:text-orange before:content-asterisk':
                      !item.reason && !item.otherReason?.trim().length,
                  })
                      }, [
                        (item.reason)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(item.reason), 1)
                            ], 64))
                          : (item.isOtherReasonOptionOpen)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString($data.locale.return_reason_other_reason_input_label), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString($data.locale.return_reason_select_label), 1)
                              ], 64))
                      ], 2),
                      (_openBlock(), _createElementBlock("svg", {
                        width: "14",
                        height: "10",
                        viewBox: "0 0 16 10",
                        fill: "none",
                        class: _normalizeClass(["transition-transform duration-200 ease-in-out", {'rotate-180': item.isSelectReasonDropdownOpen}])
                      }, _cache[5] || (_cache[5] = [
                        _createElementVNode("path", {
                          d: "M1.25 1.625L8 8.375L14.75 1.625",
                          stroke: "#121212",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, null, -1)
                      ]), 2))
                    ], 8, _hoisted_17),
                    _createElementVNode("div", {
                      class: _normalizeClass(["grid transition-grid-template-rows duration-500", item.isSelectReasonDropdownOpen ? 'grid-rows-1' : 'grid-rows-0'])
                    }, [
                      _createElementVNode("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.reasonOptions, (reason) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: reason,
                            tabindex: "0",
                            class: _normalizeClass(["cursor-pointer rounded-4 py-10 outline-none transition-all duration-200 hover:bg-black-100 focus-visible:bg-black-100", {'pointer-events-none bg-black-100 pl-6': reason === item.reason}]),
                            onClick: _withModifiers($event => ($options.closeItemDropdowns(item.uniqueKey)), ["self"])
                          }, [
                            _createTextVNode(_toDisplayString(reason) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": $event => ((item.reason) = $event),
                              required: "",
                              tabindex: "-1",
                              value: reason,
                              type: "radio",
                              name: "reason",
                              class: "visually-hidden"
                            }, null, 8, _hoisted_20), [
                              [_vModelRadio, item.reason]
                            ])
                          ], 10, _hoisted_19))
                        }), 128)),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["w-full rounded-4 py-10 text-left outline-none transition-all duration-200 hover:bg-black-100 focus-visible:bg-black-100", {
                      'pointer-events-none bg-black-100 pl-6': item.isOtherReasonOptionOpen,
                    }]),
                          onClick: _withModifiers($event => ($options.openItemOtherReasonOption(item.uniqueKey)), ["stop"])
                        }, _toDisplayString($data.locale.return_reason_other_reason_input_label), 11, _hoisted_21),
                        _createElementVNode("div", {
                          class: _normalizeClass(["mt-12 grid transition-grid-template-rows duration-500", item.isOtherReasonOptionOpen ? 'grid-rows-1' : 'grid-rows-0'])
                        }, [
                          _createElementVNode("div", _hoisted_22, [
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": $event => ((item.otherReason) = $event),
                              class: "mt-12 w-full resize-none border border-black-400 py-8 pl-16 text-16 focus:border-black-900 focus-visible:outline-none",
                              rows: "7",
                              placeholder: $data.locale.return_reason_other_reason_input_placeholder
                            }, null, 8, _hoisted_23), [
                              [_vModelText, item.otherReason]
                            ])
                          ])
                        ], 2)
                      ])
                    ], 2)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ], 2)
    ])
  ]))
}